__turbopack_context__.v({
  "actions": "website-pill-cta-module__AcPaZW__actions",
  "beta": "website-pill-cta-module__AcPaZW__beta",
  "blurDeep": "website-pill-cta-module__AcPaZW__blurDeep",
  "blurSoft": "website-pill-cta-module__AcPaZW__blurSoft",
  "content": "website-pill-cta-module__AcPaZW__content",
  "description": "website-pill-cta-module__AcPaZW__description",
  "eyebrow": "website-pill-cta-module__AcPaZW__eyebrow",
  "footer": "website-pill-cta-module__AcPaZW__footer",
  "footerBottom": "website-pill-cta-module__AcPaZW__footerBottom",
  "footerTop": "website-pill-cta-module__AcPaZW__footerTop",
  "frameLines": "website-pill-cta-module__AcPaZW__frameLines",
  "navigation": "website-pill-cta-module__AcPaZW__navigation",
  "scene": "website-pill-cta-module__AcPaZW__scene",
  "section": "website-pill-cta-module__AcPaZW__section",
  "tint": "website-pill-cta-module__AcPaZW__tint",
  "video": "website-pill-cta-module__AcPaZW__video",
});
